const TICKER_TEXT =
  'FASTER PAYROLL \u2022 100% NIB COMPLIANT \u2022 ZERO CALCULATORS NEEDED \u2022 TRUSTED BY 500+ TEAMS \u2022 AUTO-SYNC WITH BANKING \u2022 ';

export function TickerSection() {
  // Duplicate the text so the second copy seamlessly follows the first
  const doubled = TICKER_TEXT + TICKER_TEXT;

  return (
    <div className="bg-slate-800 text-white py-3 overflow-hidden whitespace-nowrap">
      <div className="ticker-track font-medium text-sm tracking-wider">
        {doubled}
      </div>
    </div>
  );
}
